<template>
  <div>
    <form id="jwt_form" @submit.prevent="handleJwtSubmit">
      <input type="text" name="jwt" placeholder="Enter JWT" v-model="jwt" />
      <button type="submit">Submit JWT</button>
    </form>

    <form id="continue_form" @submit.prevent="handleContinueSubmit">
      <input
        type="text"
        name="id"
        placeholder="Transaction ID"
        v-model="transactionId"
      />
      <input
        type="text"
        name="challenge_url"
        placeholder="Challenge URL"
        v-model="challengeUrl"
      />
      <input
        type="text"
        name="payload"
        placeholder="Payload"
        v-model="payload"
      />
      <button type="submit">Continue</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jwt: "",
      transactionId: "",
      challengeUrl: "",
      payload: "",
    };
  },
  //   mounted() {
  //     // Load the external JavaScript file by creating a script tag
  //     const script = document.createElement("script");
  //     script.src = "../../assets/songbird.js";
  //     script.async = true;
  //     document.head.appendChild(script);
  //   },
  methods: {
    handleJwtSubmit() {
      // Initialize Cardinal with the JWT
      Cardinal.setup("init", { jwt: this.jwt });

      // Listen for the 'setupComplete' event
      Cardinal.on("payments.setupComplete", (setupCompleteData) => {
        console.log("Setup complete", setupCompleteData);
      });

      // Listen for the 'payments.validated' event
      Cardinal.on("payments.validated", (data, jwt) => {
        switch (data.ActionCode) {
          case "SUCCESS":
            // Handle successful transaction
            break;
          case "NOACTION":
            // Handle no actionable outcome
            break;
          case "FAILURE":
            // Handle failed transaction attempt
            break;
          case "ERROR":
            // Handle service level error
            break;
        }
        console.log("Payments validated", data);
        console.log("JWT = ", jwt);
      });
    },

    handleContinueSubmit() {
      // Call the Cardinal continue method with provided values
      Cardinal.continue(
        "cca",
        {
          AcsUrl: this.challengeUrl,
          Payload: this.payload,
        },
        {
          OrderDetails: {
            TransactionId: this.transactionId,
          },
        }
      );
    },
  },
};
</script>

<style>
/* Add any custom styling here if necessary */
</style>
